import * as yup from 'yup';
import { HeroStats } from '@web/components';

export const component = HeroStats;

const statSchema = yup
  .object({
    value: yup.string(),
    label: yup.string(),
  })
  .transform(value => ({
    value: value.value,
    label: value.label,
  }));

export const schema = yup
  .object({
    stats: yup.array(statSchema),
    fontColor: yup.string(),
    backgroundColor: yup.string(),
    component: yup.string(),
  })
  .transform(value => ({
    component: value.component,
    stats: value.stats,
    fontColor: value.font_color || undefined,
    backgroundColor: value.background_color || undefined,
  }));
